/**
 * The deployment's record noun (E4, SA-385, spec D22): what staff call the
 * thing the register lists — "Orders" on a bakery, "Quotes" on a charter
 * operator, "Records" on a deployment with no vocabulary pack. Sourced
 * from `/api/features.vocabulary` through the feature store, so it is
 * known before auth completes (the sidebar wears it).
 */
import { useFeatureStore, type DeploymentVocabulary } from '@/stores/featureStore'

export interface RecordNounResult {
  singular: string
  plural: string
  pack: string | null
}

export function selectRecordNoun(vocabulary: DeploymentVocabulary): RecordNounResult {
  return {
    singular: vocabulary.record.singular,
    plural: vocabulary.record.plural,
    pack: vocabulary.pack,
  }
}

export function useRecordNoun(): RecordNounResult {
  const vocabulary = useFeatureStore((s) => s.vocabulary)
  return selectRecordNoun(vocabulary)
}
